import { DEFAULT_EODP_FR_URL_PARAMETER_VALUE } from '~/constants/RoutesEnums';
export default (function () {
  var route = useRoute();
  var isEodp = computed(function () {
    var _route$query;
    return (route === null || route === void 0 ? void 0 : (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.page) === DEFAULT_EODP_FR_URL_PARAMETER_VALUE;
  });
  return {
    isEodp: isEodp
  };
});